/* eslint-disable @typescript-eslint/dot-notation */
/* eslint-disable quote-props */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/semi */
/* eslint-disable prefer-arrow/prefer-arrow-functions */

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

import { HootsMenuModule } from './hoots-menu/hoots-menu.module';

import { IonicStorageModule } from '@ionic/storage-angular';

// import ngx-translate and the http loader
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { HttpClient, HttpClientModule } from '@angular/common/http';

import { Base64ToGallery } from '@ionic-native/base64-to-gallery/ngx';

import { Base64 } from '@ionic-native/base64/ngx';

import { Network } from '@ionic-native/network/ngx';

import { VideoPlayer } from '@ionic-native/video-player/ngx';

import { ShowHidePasswordModule } from './show-hide-password/show-hide-password.module';

import { PdfViewerModule } from 'ng2-pdf-viewer';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { ScreenOrientation } from '@awesome-cordova-plugins/screen-orientation/ngx';
import { OnFocusDirective } from './services/onfocus.directive';
import { CarviewPageModule } from './carview/carview.module';



@NgModule({
  declarations: [AppComponent, OnFocusDirective],
  imports: [HootsMenuModule, BrowserModule, IonicModule.forRoot({ animated: false }), AppRoutingModule, IonicStorageModule.forRoot(),
    HttpClientModule,
    PdfViewerModule,
    ShowHidePasswordModule,
    CarviewPageModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })],

  providers: [VideoPlayer, { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    Base64ToGallery, Network, Base64, ScreenOrientation],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }

//platformBrowserDynamic().bootstrapModule(AppModule);

// required for AOT compilation
export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http);
}

